<template>
  <div class="margin-bottom-0">
    <div class="alert alert-danger" role="alert" v-show="message.error">
      {{ message.error }}
    </div>
    <div class="alert alert-success" v-show="message.success">
      <span class="close" data-dismiss="alert">×</span>
      <strong>Success!</strong>
      {{ message.success }}
    </div>
    <div class="form-group m-b-15">
      <input type="text" class="form-control form-control-lg" name="email" id="email" v-model="email" placeholder="Enter your Email" :class="{'is-invalid': $v.email.$error}" @input="$v.email.$touch()" @keyup.enter="ask()"/>
      <div v-if="$v.email.$error" class="invalid-feedback">Email is not valid</div>
    </div>
    <div class="login-buttons">
      <button type="button" class="btn btn-primary get-started  rounded-pill btn-block" style="width: 100%; padding: 10px 16px; font-size: 18px;" @click.stop.prevent="ask()">Ask</button>
    </div>
    <div class="m-t-20 m-b-40 p-b-40 text-inverse">
      Already have an account? Click <router-link class="text-theme" :to="{ name: 'Login'}">here</router-link> to login.
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'ForgotPassword',
  mixins: [validationMixin],
  validations: {
    email: { required, email }
  },
  data() {
    return {
      email: null,
      message: {
        error: false,
        success: false
      }
    }
  },

  methods: {
    ...Vuex.mapActions(['renewPassword']),
    showErrorMessage(message) {
      this.message.error = message
    },
    showSuccessMessage(message) {
      this.message.error = null
      this.message.success = message
    },
    ask: function() {
      if (!this.$v.email.$invalid) {
        this.renewPassword({ email: this.email })
          .then(() => this.showSuccessMessage('Please check your email address for password reset instructions'))
          .catch(err => {
            let errMsgObj = JSON.parse(err.message)
            if (errMsgObj.message === 'renewPassword.email.notRegistred') {
              errMsgObj.messageText = 'The email address you have entered is not registered'
            } else {
              errMsgObj.messageText = 'Error when asking to change password'
            }
            this.showErrorMessage(errMsgObj.messageText)
          })
      } else {
        this.$v.email.$touch()
        this.showErrorMessage('Form is not valid, check before submit')
      }
    }
  }
}
</script>
<style>
.m-b-15 {
  margin-bottom: 15px !important;
}
.m-t-20 {
  margin-top: 20px !important;
}
.m-b-40 {
  margin-bottom: 40px !important;
}
.p-b-40 {
  padding-bottom: 40px !important;
}
.text-grey-darker {
    color: #929ba1!important;
}
@media (max-width:450px){
  .login.login-with-news-feed .right-content{
    width: 100%;
  }
  .login.login-with-news-feed .login-content{
    padding:30px 0px 0 80px;
  }
  .login.login-with-news-feed .login-header{
    margin: auto;
    left: auto;
    right: 0;
  }
  .login.login-with-news-feed .login-content{
    width: auto;
  }
  .login.login-with-news-feed .login-header .brand{
    left: 0;
  }
  .login.login-with-news-feed .login-content{
    padding: 30px 30px 60px 30px;
  }
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/auth/ForgotPassword.vue